(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('[data-search-popup]');
    var input = document.getElementById('Search-Popup-Input');
    if (!popup || !input) return;

    var closeBtns = document.querySelectorAll('[data-search-popup-close]');
    var backdrop = document.querySelector('[data-search-popup-backdrop]');

    function openPopup() {
      popup.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.classList.add('search-popup-open');
      setTimeout(function () { input.focus(); }, 100);
    }

    function closePopup() {
      popup.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('search-popup-open');
      document.body.style.overflow = '';
      input.value = '';
      var grid = document.querySelector('[data-search-popup-results-grid]');
      var empty = document.querySelector('[data-search-popup-empty]');
      var results = document.querySelector('[data-search-popup-results]');
      var prevSeeAll = document.querySelector('.search-popup__see-all-wrapper');
      if (grid) grid.innerHTML = '';
      if (results) results.style.display = 'none';
      if (empty) empty.style.display = '';
      if (prevSeeAll) prevSeeAll.remove();
    }

    closeBtns.forEach(function (btn) { btn.addEventListener('click', closePopup); });
    if (backdrop) backdrop.addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    document.querySelectorAll('[data-open-search]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var drawer = document.querySelector('[data-b2b-mobile-drawer]');
        if (drawer && drawer.classList.contains('is-open')) {
          drawer.classList.remove('is-open');
          var overlay = document.querySelector('[data-b2b-mobile-overlay]');
          if (overlay) overlay.classList.remove('is-open');
          document.body.style.overflow = '';
          setTimeout(function () { openPopup(); }, 350);
        } else {
          openPopup();
        }
      });
    });

    var emptyState = document.querySelector('[data-search-popup-empty]');
    if (emptyState) {
      emptyState.addEventListener('click', function (e) {
        var swatch = e.target.closest('.search-popup-card__swatch');
        if (swatch && swatch.hasAttribute('data-href')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var swatchesContainer = swatch.parentElement;
          var card = swatch.closest('.search-popup-card-wrapper');
          if (swatchesContainer) {
            swatchesContainer.querySelectorAll('.search-popup-card__swatch').forEach(function(s) { s.classList.remove('search-popup-card__swatch--active'); });
          }
          swatch.classList.add('search-popup-card__swatch--active');
          var imgUrl = swatch.getAttribute('data-img');
          if (imgUrl && card) {
            var imgEl = card.querySelector('[data-search-card-image] img');
            if (imgEl) imgEl.src = imgUrl;
          }
          var cardLink = card ? card.querySelector('a.search-popup-card') : null;
          if (cardLink) cardLink.href = swatch.getAttribute('data-href');
          return false;
        }
        var moreBtn = e.target.closest('[data-swatch-view-more]');
        if (moreBtn) {
          e.preventDefault();
          var wrapper = moreBtn.closest('[data-swatches-wrapper]');
          if (wrapper) wrapper.classList.add('is-expanded');
          return false;
        }
      });
    }

    input.addEventListener('keydown', function (e) {
      e.stopPropagation();
      if (e.key === 'Escape') { closePopup(); return; }
      if (e.key === 'Enter') {
        e.preventDefault();
        var t = input.value.trim();
        if (t.length >= 1) {
          window.location.href = '/search?q=' + encodeURIComponent(t);
        }
        return;
      }
    }, true);

    var timer = null;
    var searchCache = {};
    var currentAbortController = null;
    var currentSearchTerm = '';

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var t = input.value.trim();

      if (currentAbortController) {
        currentAbortController.abort();
        currentAbortController = null;
      }

      if (t.length < 1) {
        var grid = document.querySelector('[data-search-popup-results-grid]');
        var empty = document.querySelector('[data-search-popup-empty]');
        var results = document.querySelector('[data-search-popup-results]');
        if (grid) grid.innerHTML = '';
        if (results) results.style.display = 'none';
        if (empty) empty.style.display = '';
        return;
      }

      var grid = document.querySelector('[data-search-popup-results-grid]');
      var empty = document.querySelector('[data-search-popup-empty]');
      var results = document.querySelector('[data-search-popup-results]');
      var prevSeeAll = document.querySelector('.search-popup__see-all-wrapper');
      if (prevSeeAll) prevSeeAll.remove();
      if (empty) empty.style.display = 'none';
      if (grid && results) {
        grid.innerHTML = '<div class="search-popup__loading-dots"><span></span><span></span><span></span></div>';
        results.style.display = '';
      }

      timer = setTimeout(function () { doSearch(t); }, 300);
    });

    function doSearch(term) {
      var grid = document.querySelector('[data-search-popup-results-grid]');
      var empty = document.querySelector('[data-search-popup-empty]');
      var results = document.querySelector('[data-search-popup-results]');
      currentSearchTerm = term;

      var cacheKey = term.toLowerCase().trim();
      if (searchCache[cacheKey]) {
        renderResults(searchCache[cacheKey], term, grid, results, empty);
        return;
      }

      if (currentAbortController) currentAbortController.abort();
      currentAbortController = new AbortController();

      fetch('/search/suggest?section_id=search-popup-results&q=' + encodeURIComponent(term) + '&type=product&resources[type]=product&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku', {
        signal: currentAbortController.signal
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (term !== currentSearchTerm) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var content = doc.querySelector('#search-popup-results-content');
        var resultCount = content ? parseInt(content.getAttribute('data-count') || '0') : 0;
        var innerGrid = content ? content.querySelector('.search-popup-results__grid') : null;
        var renderedHTML = innerGrid ? innerGrid.innerHTML : content ? content.innerHTML : '';
        searchCache[cacheKey] = { html: renderedHTML, count: resultCount, term: term };
        renderResults(searchCache[cacheKey], term, grid, results, empty);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        if (term !== currentSearchTerm) return;
        if (grid) grid.innerHTML = '<p style="font-family:Montserrat,sans-serif;font-size:13px;color:#777;grid-column:1/-1;text-align:center;">Something went wrong. Please try again.</p>';
        if (results) results.style.display = '';
        if (empty) empty.style.display = 'none';
      });
    }

    function renderResults(data, term, grid, results, empty) {
      if (!grid) return;
      grid.innerHTML = '';
      if (empty) empty.style.display = 'none';
      var prevSeeAll = grid.parentNode.querySelector('.search-popup__see-all-wrapper');
      if (prevSeeAll) prevSeeAll.remove();

      if (data.count === 0) {
        grid.innerHTML =
          '<p class="search-popup__no-results-for">No results for <span>\u2018' + term + '\u2019</span></p>' +
          '<div class="search-popup__view-all-results">' +
          '<h2 class="search-popup__view-all-title">View all results</h2>' +
          '<p class="search-popup__view-all-subtitle">Quick suggestions came up empty. View our full search for close and similar matches.</p>' +
          '<a href="/search?q=' + encodeURIComponent(term) + '" class="search-popup__go-to-results-btn">GO TO RESULTS</a>' +
          '</div>';
        if (results) results.style.display = '';
        return;
      }

      if (results) results.style.display = '';
      grid.innerHTML = data.html;

      grid.addEventListener('click', function (e) {
        var swatch = e.target.closest('.search-popup-card__swatch');
        if (swatch && swatch.hasAttribute('data-href')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var swatchesContainer = swatch.parentElement;
          var card = swatch.closest('.search-popup-card-wrapper');
          if (swatchesContainer) {
            swatchesContainer.querySelectorAll('.search-popup-card__swatch').forEach(function(s) { s.classList.remove('search-popup-card__swatch--active'); });
          }
          swatch.classList.add('search-popup-card__swatch--active');
          var imgUrl = swatch.getAttribute('data-img');
          if (imgUrl && card) {
            var imgEl = card.querySelector('[data-search-card-image] img');
            if (imgEl) imgEl.src = imgUrl;
          }
          var cardLink = card ? card.querySelector('a.search-popup-card') : null;
          if (cardLink) cardLink.href = swatch.getAttribute('data-href');
          return false;
        }
        var moreBtn = e.target.closest('[data-swatch-view-more]');
        if (moreBtn) {
          e.preventDefault();
          var wrapper = moreBtn.closest('[data-swatches-wrapper]');
          if (wrapper) wrapper.classList.add('is-expanded');
          return false;
        }
      });

      var seeAll = document.createElement('div');
      seeAll.className = 'search-popup__see-all-wrapper';
      seeAll.innerHTML =
        '<a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="search-popup__see-all-link">' +
        '<span>View all results</span>' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</a>';
      grid.insertAdjacentElement('afterend', seeAll);
    }
  });
})();
